/**
 * Every game's slug, on its own so that code running in the page can check one
 * without loading the whole game list in src/games.data.ts, which types its
 * slugs against this list.
 */
export const GAME_SLUGS = [
  'forest-runner',
  'endless-shred',
  'solitaire',
  'sudoku',
  '2048',
  'minesweeper',
  'tetris',
  'snake',
  'blockdestroyer',
  'sort-puzzle',
  'match-3',
  'memory-game',
  'quick-math',
  'pattern-challenge',
  'maze',
] as const

export type GameSlug = (typeof GAME_SLUGS)[number]
